import React from 'react';
import PropTypes from 'prop-types';
import TemplateRow from './TemplateRow';
import TemplateScheduleModal from './TemplateScheduleModal';
import isNumber from 'lodash.isnumber';
import { Button } from '../../../components';

import {
	loadTemplates,
	saveTemplate,
	createTemplate,
	deleteTemplate,
	createTemplateItem,
	saveTemplateItem,
	deleteTemplateItem,
} from './api';
import { Link } from 'react-router-dom';

export default class ScheduleBuilder extends React.Component {
	static propTypes = {
		user: PropTypes.object.isRequired,
	};

	static defaultProps = { user: {} };

	state = {
		editting: false,
		showAddForm: false,
		showModal: false,
	};

	componentDidMount() {
		this.loadTemplates();
	}

	loadTemplates = async () => {
		const { user } = this.props;
		this.setState({ isLoading: true, isError: false });
		try {
			const { data } = await loadTemplates(user.get('id'));
			this.setState({ isLoading: false, templates: data });
		} catch (e) {
			this.setState({ isLoading: false, isError: true });
		}
	};

	handleShowAddTemplateForm = () => {
		this.setState({ showAddForm: true });
	};

	handleCancelAddTemplate = () => {
		this.setState({ showAddForm: false });
	};

	handleAdd = async (template) => {
		const { templates } = this.state;
		try {
			const { data } = await createTemplate(template);
			this.setState({
				templates: [...templates, data],
				showAddForm: false,
			});
		} catch (e) {
			this.setState({ isError: true });
		}
	};

	handleSave = async (template) => {
		const templates = this.state.templates.slice();
		const templateIndex = templates.findIndex((t) => t.id === template.id);
		try {
			const { data } = await saveTemplate(template);
			templates[templateIndex] = data;
			this.setState({ templates });
		} catch (e) {
			this.setState({ isLoading: false, isError: true });
		}
	};

	handleDelete = async (template) => {
		const { templates } = this.state;
		try {
			const { data } = await deleteTemplate(template);
			if (data && data.count && data.count === 1) {
				const filtered = templates.filter((t) => t.id !== template.id);
				this.setState({ templates: filtered });
			}
		} catch (e) {
			this.setState({ isLoading: false, isError: true });
		}
	};

	handleShowEditScheduleModal = async (template) => {
		this.setState({
			showModal: true,
			selectedTemplate: template,
		});
	};

	handleCloseEditScheduleModal = () => {
		this.setState({ showModal: false, selectedTemplate: null });
	};

	handleSaveTemplateItems = async (
		newOrUpdatedItems = [],
		itemsToDelete = []
	) => {
		const { selectedTemplate } = this.state;
		const templateItems = [];
		await newOrUpdatedItems.forEach(async (templateItem) => {
			let result;
			if (isNumber(templateItem.id)) {
				result = await saveTemplateItem(templateItem);
			} else {
				result = await createTemplateItem({
					appointment_template_id: selectedTemplate.id,
					start_time: templateItem.start_time,
					end_time: templateItem.end_time,
				});
			}
			templateItems.push(result.data);
		});
		await itemsToDelete.forEach(async (templateItem) => {
			if (isNumber(templateItem.id)) {
				await deleteTemplateItem(templateItem);
			}
		});
		selectedTemplate.appointment_template_item = templateItems;
		this.setState({ showModal: false, selectedTemplate: null });
	};

	render() {
		const { user } = this.props;
		const { templates, showAddForm, showModal, selectedTemplate } = this.state;
		return (
			<div className="content-wrapper">
				<TemplateScheduleModal
					isOpen={showModal}
					template={selectedTemplate}
					onCancel={this.handleCloseEditScheduleModal}
					onSave={this.handleSaveTemplateItems}
				/>
				<ol className="breadcrumb">
					<li>
						<Link to="/">Home</Link>
					</li>
					<li>
						<Link to="/scheduling">Scheduling</Link>
					</li>
					<li className="active">Template Builder</li>
				</ol>
				<div className="text-right">
					<Button
						title="Add Template"
						label="plus"
						info
						onClick={this.handleShowAddTemplateForm}
						disabled={showAddForm}
					/>
				</div>
				<table className="table table-striped">
					<thead>
						<tr>
							<th>Template Name</th>
							<th>Description</th>
							<th colSpan="2">Active</th>
						</tr>
					</thead>
					<tbody>
						{showAddForm && (
							<TemplateRow
								template={{ provider_id: user.get('id') }}
								onSave={this.handleAdd}
								onCancel={this.handleCancelAddTemplate}
							/>
						)}
						{templates &&
							templates.map((template) => (
								<TemplateRow
									key={template.id}
									template={template}
									onSave={this.handleSave}
									onDelete={this.handleDelete}
									onClickEditSchedule={this.handleShowEditScheduleModal}
								/>
							))}
					</tbody>
				</table>
			</div>
		);
	}
}
